var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"intro-header"},[(_vm.showMobile)?_c('MobileHeader'):_vm._e(),(_vm.showExtraMobile)?_c('WideMobileHeader'):_vm._e(),(_vm.showTouch)?_c('TouchHeader'):_vm._e(),(_vm.showDesktop)?_c('DesktopHeader'):_vm._e(),(_vm.showWidescreen)?_c('WidescreenHeader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }